import * as ActionTypes from '../../constants/ActionTypes';

// Get available appointment slots
export const getAvailableSlots = (storeId, date, userTimezone = 'UTC') => ({
    type: ActionTypes.GET_AVAILABLE_SLOTS_REQUEST,
    payload: { storeId, date, userTimezone }
});

export const getAvailableSlotsSuccess = (data) => ({
    type: ActionTypes.GET_AVAILABLE_SLOTS_SUCCESS,
    payload: data
});

export const getAvailableSlotsFailure = (error) => ({
    type: ActionTypes.GET_AVAILABLE_SLOTS_FAILURE,
    payload: error
});

// Book appointment
export const bookAppointment = (appointmentData) => ({
    type: ActionTypes.BOOK_APPOINTMENT_REQUEST,
    payload: appointmentData
});

export const bookAppointmentSuccess = (appointment) => ({
    type: ActionTypes.BOOK_APPOINTMENT_SUCCESS,
    payload: appointment
});

export const bookAppointmentFailure = (error) => ({
    type: ActionTypes.BOOK_APPOINTMENT_FAILURE,
    payload: error
});

// Get user appointments
export const getUserAppointments = (params = {}) => ({
    type: ActionTypes.GET_USER_APPOINTMENTS_REQUEST,
    payload: params
});

export const getUserAppointmentsSuccess = (data) => ({
    type: ActionTypes.GET_USER_APPOINTMENTS_SUCCESS,
    payload: data
});

export const getUserAppointmentsFailure = (error) => ({
    type: ActionTypes.GET_USER_APPOINTMENTS_FAILURE,
    payload: error
});

// Cancel appointment
export const cancelAppointment = (appointmentId, reason = '') => ({
    type: ActionTypes.USER_CANCEL_APPOINTMENT_REQUEST,
    payload: { appointmentId, reason }
});

export const cancelAppointmentSuccess = (appointment) => ({
    type: ActionTypes.USER_CANCEL_APPOINTMENT_SUCCESS,
    payload: appointment
});

export const cancelAppointmentFailure = (error) => ({
    type: ActionTypes.USER_CANCEL_APPOINTMENT_FAILURE,
    payload: error
});

// Get appointment details
export const getAppointmentDetails = (appointmentId, userTimezone = 'UTC') => ({
    type: ActionTypes.GET_APPOINTMENT_DETAILS_REQUEST,
    payload: { appointmentId, userTimezone }
});

export const getAppointmentDetailsSuccess = (appointment) => ({
    type: ActionTypes.GET_APPOINTMENT_DETAILS_SUCCESS,
    payload: appointment
});

export const getAppointmentDetailsFailure = (error) => ({
    type: ActionTypes.GET_APPOINTMENT_DETAILS_FAILURE,
    payload: error
});

// Get timezones
export const getTimezones = () => ({
    type: ActionTypes.GET_TIMEZONES_REQUEST
});

export const getTimezonesSuccess = (timezones) => ({
    type: ActionTypes.GET_TIMEZONES_SUCCESS,
    payload: timezones
});

export const getTimezonesFailure = (error) => ({
    type: ActionTypes.GET_TIMEZONES_FAILURE,
    payload: error
});

// Clear appointment errors
export const clearAppointmentErrors = () => ({
    type: ActionTypes.CLEAR_APPOINTMENT_ERRORS
});

// Clear appointment success states
export const clearAppointmentSuccess = () => ({
    type: ActionTypes.CLEAR_APPOINTMENT_SUCCESS
});

// Reset appointment state
export const resetAppointmentState = () => ({
    type: ActionTypes.RESET_APPOINTMENT_STATE
});

// Set selected appointment
export const setSelectedAppointment = (appointment) => ({
    type: ActionTypes.SET_SELECTED_APPOINTMENT,
    payload: appointment
});

// Clear selected appointment
export const clearSelectedAppointment = () => ({
    type: ActionTypes.CLEAR_SELECTED_APPOINTMENT
});

// Update appointment in list (for real-time updates)
export const updateAppointmentInList = (appointment) => ({
    type: ActionTypes.UPDATE_APPOINTMENT_IN_LIST,
    payload: appointment
});

// Remove appointment from list
export const removeAppointmentFromList = (appointmentId) => ({
    type: ActionTypes.REMOVE_APPOINTMENT_FROM_LIST,
    payload: appointmentId
});

// Set appointment loading state
export const setAppointmentLoading = (loading) => ({
    type: ActionTypes.SET_APPOINTMENT_LOADING,
    payload: loading
});

// Set slots loading state
export const setSlotsLoading = (loading) => ({
    type: ActionTypes.SET_SLOTS_LOADING,
    payload: loading
});
